import React from 'react';
// import { Carousel } from 'react-bootstrap';

function BusinessBanner() {
    
    return (
        <>
	    <div className="banner">
            <img
                src="/assets/images/Process.jpg"
                 alt="Improve Business Efficiency with Virtual Assistants"
                title="ConnectMyVA - Business Support with Expert Virtual Assistants"
                className="bannerImage"
            />
        </div>
        </>
    )
}

export default BusinessBanner
